import { connect } from "react-redux";

import * as queries from "./queries";
import * as commands from "./commands";
import * as actions from "./actions";

function mapStateToProps(state) {
  return { loanNotes: state.loanNotes };
}

function mapDispatchToProps(dispatch) {
  return {
    getLoanNotesById: (loanId) => {
      dispatch(queries.get_loan_notes_by_id(loanId));
    },

    createLoanNote: (loanId, text) => {
      dispatch(commands.create_loan_note(loanId, text));
    },

    confirmNoteCreate: (loanId) => {
      dispatch(actions.confirm(loanId));
    },
  };
}

const loanNotesConnect = connect(mapStateToProps, mapDispatchToProps);
export default loanNotesConnect;
